/**
 * Removes all data stored in the local storage.
 *
 * @version 1.9.0
 * @module Storage
 * @name storageClear
 * @example
 *
 * storageClear();
 *
 */
export const storageClear = () => window.localStorage.clear();
